import React from 'react'

const DatabaseStack = () => {
  return (
    <div className='stack-card'>
    <h4>Database</h4>
    <div className='stack-card-list'>
        <p className='stack-border-color-firestore'>Firestore</p>
        <p>Firebase Realtime</p>
        <p className='stack-border-color-postgres'>PostgreSQL</p>
    </div>
</div>
  )
}

export default DatabaseStack